import React, {useEffect, useState} from 'react';
import { Card, Table, Badge, Dropdown, Pagination } from 'react-bootstrap';
import {authService} from "../../services/authService";
import NotificationService from "../../services/NotificationService";
import {userService} from "../../services/userService";
import {businessYearService} from "../../services/businessYearService";
import eventEmitter from "../../shared/eventEmitter";
import {EventEmitterTypes} from "../../shared/eventEmitterEnum";
import {useNavigate} from "react-router-dom";
import {stringify} from "node:querystring";
import {dayColumnsAbbreviated} from "../../shared/DaysOfTheWeek";
import AreaSchedulesModal from "./modals/AreaSchedulesModal";
import {CustomToggle} from "../../shared/components/CustomYearlySettingsToggleOptions";
import ConfirmationModal from "../ConfirmationModal";

interface DayRowProps {
    flags: number;
}

const DayOfWeekRow: React.FC<DayRowProps> = ({ flags }) => {
    return (
        <>
            {dayColumnsAbbreviated.map((day, index) => (
            <td key={index}>
                {(flags & day.flag) !== 0 ? day.name : ""}
            </td>
            ))}
        </>
    );
};

export interface Settings {
    created: Date,
    current: boolean,
    maximumWorkAmountPerDay: number,
    scheduleEndDate: Date,
    scheduleStartDate: Date,
    year: number
}

interface YearlySettingsDetailsProps {
    details: Settings;
}

export interface AreaSchedule {
    areaScheduleId: string,
    city: string,
    county: string,
    state: string,
    postalCode: number,
    dayOfWeekFlags: number
}

const AreaSchedulesCard: React.FC<YearlySettingsDetailsProps> = ({details}) => {
    const [areaSchedules, setAreaSchedules] = useState<AreaSchedule[]>([]);
    const [activeModalData, setActiveModalData] = useState<any>();
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteRecordData, setDeleteRecordData] = useState(null);

    useEffect(() => {
        businessYearService.getAreaSchedule(details.year).then(r => setAreaSchedules(r));
    }, []);
    useEffect(() => {
        const refreshListener = () => {
            businessYearService.getAreaSchedule(details.year).then(res => {
                setAreaSchedules(res);
            });
        };

        eventEmitter.on(EventEmitterTypes.REFRESH_LOADED_YEAR_AREA_SCHEDULES, refreshListener);

        return () => {
            eventEmitter.off(EventEmitterTypes.REFRESH_LOADED_YEAR_AREA_SCHEDULES, refreshListener);
        };
    }, []);

    const deleteRecord = () => {
        businessYearService.deleteAreaSchedule(details.year, deleteRecordData).then(r => eventEmitter.emit(EventEmitterTypes.REFRESH_LOADED_YEAR_AREA_SCHEDULES));
    }
    
    function getLocation(schedule: AreaSchedule) {
        let retString = ''
        if(schedule.city){
            retString += schedule.city + ', ';
        }
        if(schedule.county){
            retString += schedule.county + ', ';
        }
        if(schedule.postalCode){
            retString += schedule.postalCode;
        }
        if(schedule.state){
            retString += `${schedule.state}`;
        }
        return retString;
    }
    return (
        <><div className="card yearlySettingsCard">
            <div className="cardHeader">
                <h2 className="">
                                    <span className="cuteIcon purple">
                                        <i className="fa-solid fa-map-location-dot"></i>
                                    </span>
                    Area Schedules
                </h2>
                <div className="cardAction">
                    <button type="button" className="btn btn-settings" onClick={() => {
                        setActiveModalData(null);
                        setShowModal(true);
                    }}>
                        <i className="fa-regular fa-plus"></i> add
                    </button>
                </div>
            </div>
            <div className="cardTable">
                <table className="table table-sm table-hover align-middle">
                    <thead>
                    <tr>
                        <th>Location</th>
                        <th>M</th>
                        <th>T</th>
                        <th>W</th>
                        <th>Th</th>
                        <th>F</th>
                        <th>Sat</th>
                        <th>Sun</th>
                        <th className="text-end">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {areaSchedules.map(area => {
                        return (
                            <tr>
                                <td>{getLocation(area)}</td>
                                <DayOfWeekRow flags={area.dayOfWeekFlags} />
                                <td className="text-end">
                                    <Dropdown style={{display: 'flex', justifyContent: 'flex-end'}} align="end"
                                              className="text-end">
                                        <Dropdown.Toggle as={CustomToggle} id="priceSqFtBtn">
                                            <i className="fa-solid fa-ellipsis"></i>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item
                                                onClick={() => {
                                                    setActiveModalData(area);
                                                    setShowModal(true);
                                                }}
                                            >
                                                <i className="fa-light fa-pencil fa-fw"></i> Edit
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                className={'text-danger'}
                                                onClick={() => {
                                                    setShowDeleteModal(true);
                                                    setDeleteRecordData(area.areaScheduleId)
                                                }}
                                            >
                                                <i className="fa-light fa-trash fa-fw"></i> Delete
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            </div>
        </div>
        <AreaSchedulesModal year={details.year} show={showModal} toggle={() => setShowModal(false)} details={activeModalData}/>
        <ConfirmationModal show={showDeleteModal} toggle={() => setShowDeleteModal(false)} onConfirm={deleteRecord}/>
        </>
    );
};

export default AreaSchedulesCard;
